import { Box, Link, List, ListItem, Typography } from "@mui/material";
import NextLink from "next/link";
import React from "react";
export const FooterMenu = ({ headingComponent, items, title }) => (React.createElement(Box, { component: "aside" },
    React.createElement(Typography, { component: headingComponent, sx: { pb: { xs: 2, lg: 3 }, width: "100%", textAlign: { xs: "center", sm: "left" } }, variant: "h5" }, title),
    items.length > 0 && (React.createElement(List, null, items.map(({ external = false, label, path }) => (React.createElement(ListItem, { key: `footer-menu-${title}-item-${label}`, sx: { px: { xs: 0.25, lg: 0 }, py: { xs: 0.5, lg: 0 }, width: "100%" } },
        React.createElement(Typography, { variant: "body1", sx: {
                a: {
                    color: "white",
                    px: 0,
                    py: 0,
                    textDecoration: "none",
                    "&:hover": {
                        textDecoration: "underline",
                    },
                },
                width: "100%",
                textAlign: {
                    xs: "center",
                    sm: "left",
                },
            } }, external ? (React.createElement(Link, { className: "external", href: path }, label)) : (React.createElement(NextLink, { className: "internal", href: path }, label))))))))));
//# sourceMappingURL=menu.js.map